import { Interface } from '@ethersproject/abi'
import { BigNumber } from '@ethersproject/bignumber'
import { ChainId, MULTICALL_ADDRESS, NATIVE_CURRENCY } from '../constants'
import { Currency, CurrencyValue, Token } from '../model'
import { useChainCall } from './useChainCalls'
import { useEthers } from './useEthers'

export function useBalance(currency?: Currency) {
  const { chainId, account } = useEthers()

  const data = useChainCall(getCall(chainId, currency, account))
  if (data && currency) {
    return new CurrencyValue(currency, BigNumber.from(data))
  }
}

const coder = new Interface([
  'function balanceOf (address) view returns (uint256)',
  'function getEthBalance (address) view returns (uint256)',
])

function getCall(chainId?: ChainId, currency?: Currency, account?: string | null) {
  if (!currency || !account || currency.chainId !== chainId) {
    return
  }
  const isNative = Object.values(NATIVE_CURRENCY).includes(currency)
  const address = currency instanceof Token && currency.address
  if (!isNative && !address) {
    return
  }
  if (address) {
    return { address, data: coder.encodeFunctionData('balanceOf', [account]) }
  } else {
    return {
      address: MULTICALL_ADDRESS[chainId],
      data: coder.encodeFunctionData('getEthBalance', [account]),
    }
  }
}
